import React from 'react';

import styled from 'styled-components';

import {
  Backdrop,
  ButtonTertiary,
  DialogAlert,
  LoadingIndicator,
  Type,
} from '@spotify-internal/encore-creator-web';

import { Delay } from '../../../../../shared/components/Delay';
import { darkModeKleinBlue } from '../../../utils';
import { DarkModeLoadingIndicator } from '../../../Elements';

type DeleteConfirmationProps = {
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteConfirmation(props: DeleteConfirmationProps) {
  function onCloseBackdrop() {
    if (!props.loading) {
      props.onCancel();
    }
  }

  return (
    <Backdrop center onClose={onCloseBackdrop}>
      {props.loading ? (
        <Loading />
      ) : (
        <DeleteConfirmationDialog
          onCancel={props.onCancel}
          onConfirm={props.onConfirm}
        />
      )}
    </Backdrop>
  );
}

function Loading() {
  return (
    <Delay time={300}>
      <DarkModeLoadingIndicator indicatorSize={LoadingIndicator.lg} />
    </Delay>
  );
}

const BlueButtonTertiary = styled(ButtonTertiary).attrs({
  buttonSize: ButtonTertiary.sm,
  condensed: true,
})`
  color: ${darkModeKleinBlue};
`;

function DeleteConfirmationDialog(
  props: Omit<DeleteConfirmationProps, 'loading'>,
) {
  return (
    <DialogAlert
      dialogTitle="Remove Artist Fundraising Pick?"
      body={
        <Type as={Type.p} condensed>
          This will remove the fundraising link from the top of your profile on
          Spotify.
        </Type>
      }
      footer={
        <div>
          <ButtonTertiary
            buttonSize={ButtonTertiary.sm}
            condensed
            onClick={props.onCancel}
          >
            Cancel
          </ButtonTertiary>
          <BlueButtonTertiary onClick={props.onConfirm}>
            Remove
          </BlueButtonTertiary>
        </div>
      }
    />
  );
}
